<template>
  <div class="keyword-search-result-list" data-scroll-element="true" ref="scrollWrapper">
    <div class="keyword-result-count-info" v-if="totalCount > 0">
      <span class="dark-purple">'{{externalInputSearchKeyword}}'</span> {{getSectionText()}} 검색결과가 <span class="dark-purple">{{totalCount}}</span>건 있어요.
    </div>
    <div v-if="showEmptyList" class="empty-cell-list">
      <div class="attention-mark-area">
        <EmptyIcon />
      </div>
      <div class="text-area">
        <span v-once class="keyword-color">'{{externalInputSearchKeyword}}'</span> {{getSectionText()}} 검색결과가 없어요.<br/>
        다른 탭을 선택해보세요.
      </div>
    </div>
    <infinite-scroll-cell-list v-if="cellList.length > 0"
                               key="infinite-scroll-cell-list-all-content-list"
                               :cell-list="cellList"
                               :thumbnail-info="thumbnailInfo"
                               :container-class-name="getCellListContainerClassName"
                               v-on:load-more="loadMore"
                               :loading="loading"
    ></infinite-scroll-cell-list>
    <infinite-scroll-multi-band :multi-section-list="multiSectionList" key="infinite-multi-band"
                           v-on:load-more="loadMore"
                           :loading="loading"
                           v-if="type === 'theme'"
    ></infinite-scroll-multi-band>
      <customer-support v-if="((noticeList && noticeTotalCount > 0) || (faqList && faqTotalCount > 0))"
                       :faq-list="faqList"
                       :faq-total-count="faqTotalCount"
                       :plus="plus"
                       :notice-list="noticeList"
                       :notice-total-count="noticeTotalCount"
                       :total-count="+totalCount"
                       :keyword="externalInputSearchKeyword"
                       :type="type"
                       >
      </customer-support>
  </div>
</template>

<script>
import InfiniteScrollCellList from '@/components/section/template/cell/InfiniteScrollCellList'
import { SearchService } from '@/common/api/api.service'
import { getBandTypeInfoByCellType } from '@/common/image.util'
import { get } from 'lodash'
import { mapGetters } from 'vuex'
import EmptyIcon from '@/assets/svg/common/img_empty.svg'
import MultiSectionModel from '@/common/model/MultiSectionModel'
import CustomerSupport from '@/components/search/CustomerSupport'
import { EventBus } from '@/components/eventbus/EventBus'
import InfiniteScrollMultiBand from '@/components/section/template/cell/InfiniteScrollMultiBandList'
export default {
  name: 'SearchResultList',
  props: ['type', 'keyword'],
  components: {
    InfiniteScrollMultiBand,
    InfiniteScrollCellList,
    EmptyIcon,
    CustomerSupport
  },
  data () {
    return {
      offset: 0,
      limit: 20,
      showEmptyList: false,
      endOfList: false,
      cellList: [],
      multiSectionList: [],
      faqList: [],
      noticeList: [],
      thumbnailInfo: {},
      totalCount: 0,
      faqOffset: 0,
      noticeOffset: 0,
      faqTotalCount: 0,
      noticeTotalCount: 0,
      loading: true
    }
  },
  methods: {
    getSectionText () {
      let res = ''
      switch (this.type) {
        case 'program':
          res = '프로그램'
          break
        case 'vod':
          res = '에피소드'
          break
        case 'live':
          res = 'LIVE'
          break
        case 'movie':
          res = '영화'
          break
        case 'clip':
          res = 'TV컷'
          break
        case 'theme':
          res = '에디터Pick'
          break
        case 'faq':
          res = '고객지원'
          break
      }
      return res
    },
    loadMore () {
      if (this.endOfList) return
      if (this.loading) return
      this.setData('loadMore')
    },
    setCustomerData (type) {
      // this.totalCount = 0
      if (type === 'faq' || type === 'all') {
        SearchService.keywordSearch({
          keyword: this.externalInputSearchKeyword,
          orderby: this.orderby,
          limit: 10,
          offset: this.faqOffset,
          type: 'faq',
          requestId: 'search-by-keyword-faq'
        }).then((faqRes) => {
          const faqCount = parseInt(get(faqRes, ['data', '0', 'totalcount'], '0'))
          this.faqList = this.faqList.concat(get(faqRes, ['data', '1', 'list'], []))
          this.faqTotalCount = faqCount
          if (this.faqOffset === 0) {
            this.totalCount = this.totalCount + this.faqTotalCount
            this.showEmptyList = this.totalCount === 0
          }
          this.faqOffset += 10
        })
      }
      if (type === 'notice_list' || type === 'all') {
        SearchService.keywordSearch({
          keyword: this.externalInputSearchKeyword,
          orderby: this.orderby,
          limit: 10,
          offset: this.noticeOffset,
          type: 'notice',
          requestId: 'search-by-keyword'
        }).then((noticeRes) => {
          const noticeCount = parseInt(get(noticeRes, ['data', '0', 'totalcount'], '0'))
          this.noticeList = this.noticeList.concat(get(noticeRes, ['data', '1', 'list'], []))
          this.noticeTotalCount = noticeCount
          if (this.noticeOffset === 0) {
            this.totalCount = this.totalCount + this.noticeTotalCount
            this.showEmptyList = this.totalCount === 0
          }
          this.noticeOffset += 10
        })
      }
    },
    setData () {
      if (this.type === 'theme') {
        this.loading = true
        SearchService.keywordSearchCF({
          keyword: this.externalInputSearchKeyword,
          orderby: this.orderby,
          limit: this.limit,
          offset: this.offset,
          type: this.type,
          requestId: 'search-by-keyword'
        }).then(({ data }) => {
          if (this.offset === 0) {
            this.totalCount = get(data, 'totalcount', '0')
          }
          const resMultiSectionList = get(data, 'multisectionlist', []).map((multiSection) => {
            return new MultiSectionModel(multiSection)
          })
          if (resMultiSectionList.length === 0) {
            this.endOfList = true
          }
          this.showEmptyList = +this.totalCount === 0 && resMultiSectionList.length === 0
          this.offset += this.limit
          this.multiSectionList = this.multiSectionList.concat(resMultiSectionList)
          this.loading = false
        })
      } else if (this.type === 'faq') {
        this.reset()
        this.setCustomerData('all')
      } else {
        this.loading = true
        SearchService.keywordSearchList({
          orderby: 'score',
          keyword: this.externalInputSearchKeyword,
          limit: this.limit,
          offset: this.offset,
          type: this.type,
          requestId: 'search-by-keyword'
        }).then(({ data }) => {
          if (this.offset === 0) {
            this.thumbnailInfo = getBandTypeInfoByCellType(get(data, ['cell_toplist', 'cell_type'], ''))
            this.totalCount = parseInt(get(data, ['cell_toplist', 'totalcount'], 0))
          }
          const resCellList = get(data, ['cell_toplist', 'celllist'], [])
          if (resCellList.length === 0) this.endOfList = true
          this.showEmptyList = this.cellList.length === 0 && resCellList.length === 0
          this.offset += this.limit
          this.cellList = this.cellList.concat(resCellList)
        })
        this.loading = false
      }
    },
    reset () {
      this.offset = 0
      this.limit = 20
      this.showEmptyList = false
      this.endOfList = false
      this.cellList = []
      this.multiSectionList = []
      this.faqList = []
      this.noticeList = []
      this.thumbnailInfo = {}
      this.totalCount = 0
      this.faqOffset = 0
      this.noticeOffset = 0
      this.faqTotalCount = 0
      this.noticeTotalCount = 0
    },
    plus (type) {
      this.setCustomerData(type)
    }
  },
  computed: {
    ...mapGetters(['externalInputSearchKeyword']),
    getCellListContainerClassName () {
      return `cell-list responsive cell-${this.thumbnailInfo.type}`
    }
  },
  mounted () {
    this.setData('mounted')
  },
  created () {
    EventBus.$on('change-keyword', this.setData)
  },
  beforeDestroy () {
    EventBus.$off('change-keyword', this.setData)
  },
  watch: {
    type: function (newVal, oldVal) {
      this.reset()
      this.$nextTick(() => {
        this.setData('watch')
      })
    }
  }
}
</script>
<style scoped>
  .keyword-search-result-list {
    position: relative;
    width: 100%;
    height: 100%;
    /*padding-top: 72px;*/
  }
  .keyword-result-count-info {
    position: relative;
    width: 100%;
    padding: 17px 0;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #a5a5a5;
  }
  .empty-cell-list{
    padding-top: 72px;
  }
  .empty-cell-list .attention-mark-area {
    height: 50px;
    width: 50px;
    position: relative;
    margin: 0 auto;
  }
  .empty-cell-list .text-area {
    text-align: center;
    margin-top: 16px;
    color: #a5a5a5;
    font-size: 14px;
    line-height: 20px;
  }
  .keyword-color {
    color: #3887ff;
  }
</style>
